import { MobileDatePicker } from '@mui/x-date-pickers'
import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import { getBranchList, getCatalogList, getGroupsList } from '../setting/services/settingApi'
import api from '../../api/api'
import { saveAs } from 'file-saver';
import { Box, Button, CircularProgress, FormControl, Menu, MenuItem, Select, TextField } from '@mui/material'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { REPORT_CONFIG } from './config'

const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
export default function ReportStock() {
    const [branchs, setBranchs] = useState([])
    const [Catalog, setCatalog] = useState([])
    const [CatalogNo, setCatalogNo] = useState('')
    const [BranchNo, setBranchsNo] = useState('')
    const [s, setS] = useState('')
    const [g, setG] = useState('')
    const [Groups, setGroups] = useState([])
    const [cis, setCis] = useState('')
    const [sumValue, setSumValue] = useState()
    const [loadingDownload, setloadingDownload] = useState(false);
    const [loading, setloading] = useState(false);

    const [showCost, setshowCost] = useState('0')
    const [date, setDate] = useState(dayjs(new Date()))
    const [reports, setReports] = useState([])
    const { profile } = useSelector(state => state.profile)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        getBranchList(null, setBranchs)
        getCatalogList(null, setCatalog)
        getGroupsList(null, setGroups)

        LoadReport()

    }, [])

    const breedClass = [
        {
            value: 'หลัก'
        },
        {
            value: 'ขยาย'
        },
        {
            value: 'จำหน่าย'
        }
    ]

    const seasons = [
        {
            value: 'แล้ง'
        },
        {
            value: 'ฝน'
        }
    ]
    function calculateSum() {
        const sumValue = { Reserved: 0, Available: 0 };

        for (const row of reports) {
            sumValue.Reserved += +row.Reserved
            sumValue.Available += +row.Available
        }
        setSumValue(sumValue)
    }
    useEffect(() => {
        calculateSum()
    }, [reports])
    async function getReportStock(body, mode, format) {

        const url = `${REPORT_CONFIG.requests.getReportStock.url}/${mode}`;

        let _params = '';
        let _date = '';
        let _s = '';
        let _g = '';
        let _c = '';
        let _cis = '';
        let _branchNo = '';
        let _showCost = '';
        let _format = '';


        if (body.date) {
            _date = 'date=' + body.date;
        }

        if (body.s) {
            _s = '&s=' + (body.s !== '-' ? body.s : '');
        }
        if (body.g) {
            _g = '&g=' + (body.g !== '-' ? body.g : '');
        }
        if (body.c) {
            _c = '&c=' + (body.c !== '-' ? body.c : '');
        }
        if (body.cis) {
            _cis = '&cis=' + (body.cis !== '-' ? body.cis : '');
        }
        if (body.branchNo) {
            _branchNo = '&branchNo=' + (body.branchNo !== '-' ? body.branchNo : '');
        }
        if (body.showCost) {
            _showCost = '&showCost=' + body.showCost;
        }

        if (format) {
            _format = '&format=' + format;
        }
        _params = '?' + _date + _s + _c + _cis + _branchNo + _showCost + _format

        if (mode === 'file') {
            setloadingDownload(true)
            const res = await api.get(url + _params, { responseType: 'arraybuffer' })
            const data = res.data

            if (format) {
                const blob = new Blob([data], { type: 'application/pdf' });
                saveAs(blob, 'รายงานสถานการณ์การตลาดและคลังเมล็ดพันธุ์ (กมข-20404)');

            } else {
                const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, 'รายงานสถานการณ์การตลาดและคลังเมล็ดพันธุ์ (กมข-20404)');
            }
            setloadingDownload(false)
        } else {
            setloading(true)
            const res = await api.get(url + _params)
            const data = res.data.result
            setReports(data)
            setloading(false)
        }

    }
    async function LoadReport() {
        const body = {
            date: date ? dayjs(date).format('YYYY-MM-DD') : '',
            branchNo: BranchNo || undefined,
            s: s || undefined,
            g: g || undefined,
            c: CatalogNo || undefined,
            cis: cis || undefined,
            showCost: showCost === '0' ? '' : showCost || undefined,
        };
        getReportStock(body, 'data')
    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid p-0">
                    <form>
                        <div class="row  no-gutters">

                            <div class="col-12 col-lg-2">
                                <div class="row no-gutters">
                                    <div class="col-12 header-row border-1 ">
                                        ตัวกรอง
                                    </div>
                                </div>
                                <div class="row no-gutters p-2 border-1">


                                    <div class="col-12">
                                        <label class="labelInput">ฤดู</label>

                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={s || '-'} onChange={e => setS(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {seasons?.map((x) => (
                                                        <MenuItem value={x.value}>{x.value}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>

                                    </div>
                                    <div class="col-12">

                                        <label class="labelInput">วันที่</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '20px', borderRadius: '25px' }}>
                                            <MobileDatePicker
                                                dayOfWeekFormatter={(day) => `${day}`}
                                                value={date} onChange={e => setDate(e)}
                                                slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: date } }}
                                                slots={{
                                                    textField: BrowserInput,
                                                }}
                                            />
                                        </Box>



                                    </div>
                                    {profile?.BranchNo?.BranchNo === '00' &&
                                        <div class="col-12">

                                            <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                                <FormControl variant="standard" fullWidth >
                                                    <Select value={BranchNo || '-'} onChange={e => setBranchsNo(e.target.value)} disableUnderline >
                                                        <MenuItem value='-'>-</MenuItem>
                                                        {branchs?.map((x) => (
                                                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </div>}
                                    <div class="col-12">

                                        <label class="labelInput">ประเภทข้าว</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={g || '-'} onChange={e => setG(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {Groups?.map((x) => (
                                                        <MenuItem value={x?.GroupNo}>{x?.GroupName}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </div>
                                    <div class="col-12">

                                        <label class="labelInput">พันธุ์ข้าว</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={CatalogNo || '-'} onChange={e => setCatalogNo(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {Catalog?.map((x) => (
                                                        <MenuItem value={x?.CatalogNo}>{x?.CatalogName}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </div>


                                    <div class="col-12">
                                        <label class="labelInput">ชั้นพันธุ์</label>
                                        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                            <FormControl variant="standard" fullWidth >
                                                <Select value={cis || '-'} onChange={e => setCis(e.target.value)} disableUnderline >
                                                    <MenuItem value='-'>-</MenuItem>
                                                    {breedClass?.map((x) => (
                                                        <MenuItem value={x.value}>{x.value}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </div>
                                    <div class="col-12">

                                        <Button onClick={LoadReport} disabled={loading ? true : false} variant='contained' className="ButtomSearch">{loading ? <CircularProgress size={'18px'} color="inherit" /> : 'ค้นหา'} </Button>

                                    </div >

                                </div >
                            </div >
                            <div class="col-12 col-lg-10">
                                <div class="row no-gutters">
                                    <div class="col-12 d-flex justify-content-between header-row border-1 ">
                                        <div>
                                            รายงานสถานการณ์การตลาดและคลังเมล็ดพันธุ์ (กมข-20404)
                                        </div>
                                        <Button variant='contained'
                                            id="basic-button"
                                            aria-controls={open ? 'basic-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open ? 'true' : undefined}
                                            disabled={loadingDownload ? true : false}
                                            onClick={handleClick}>{loadingDownload ? <CircularProgress size={'18px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>
                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}
                                            PaperProps={{  
                                                style: {  
                                                  width: 100,  
                                                },
                                            }}
                                        >
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    date: date ? dayjs(date).format('YYYY-MM-DD') : '',
                                                    branchNo: BranchNo || undefined,
                                                    s: s || undefined,
                                                    g: g || undefined,
                                                    c: CatalogNo || undefined,
                                                    cis: cis || undefined,
                                                    showCost: showCost === '0' ? '' : showCost || undefined,
                                                };
                                                getReportStock(body, 'file')

                                                handleClose()
                                            }}>Excel</MenuItem>
                                            <MenuItem onClick={() => {
                                                const body = {
                                                    date: date ? dayjs(date).format('YYYY-MM-DD') : '',
                                                    branchNo: BranchNo || undefined,
                                                    s: s || undefined,
                                                    g: g || undefined,
                                                    c: CatalogNo || undefined,
                                                    cis: cis || undefined,
                                                    showCost: showCost === '0' ? '' : showCost || undefined,
                                                };
                                                // setFormat('pdf')
                                                getReportStock(body, 'file', 'pdf')

                                                handleClose()
                                            }}>Pdf</MenuItem>
                                        </Menu>
                                    </div >

                                </div >
                                <div class="row no-gutters border-1 pt-3">
                                    <div class="report col-12">
                                        <div class="table-responsive-sm" style={{height:'auto'}}>
                                            <table class="table table-bordered table-sm table-hover">
                                                <thead class="sticky-thead">
                                                    <tr>
                                                        <th scope="col" rowspan="2">ที่</th>
                                                        <th scope="col" rowspan="2">ชนิดข้าว</th>
                                                        <th scope="col" rowspan="2">ประเภทข้าว</th>
                                                        <th scope="col" rowspan="2">พันธุ์ข้าว</th>
                                                        <th scope="col" rowspan="2">ชั้นพันธุ์</th>
                                                        <th scope="col" rowspan="2">ฤดู</th>
                                                        <th scope="col" rowspan="2">ปี</th>
                                                        <th scope="col" rowspan="2">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                                        <th scope="col" colspan="2">เมล็ดพันธุ์คงคลัง (กิโลกรัม)</th>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col">สำรอง</th>
                                                        <th scope="col">พร้อมจำหน่าย</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {reports?.map((report, i) => (

                                                        <tr class="cp">
                                                            <td>{i + 1}</td>
                                                            <td>{report.TypeName}</td>
                                                            <td>{report.GroupName}</td>
                                                            <td>{report.CatalogName}</td>
                                                            <td>{report.ClassName}</td>
                                                            <td>{report.Season}</td>
                                                            <td>{report.Year}</td>
                                                            <td>{report.BranchName}</td>
                                                            <td>{report.Reserved.toLocaleString()}</td>
                                                            <td>{report.Available.toLocaleString()}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <thead class="sticky-tfooter">
                                                    <tr>
                                                        <th scope="col" colspan="8">รวม</th>
                                                        <th scope="col">{sumValue?.Reserved.toLocaleString()}</th>
                                                        <th scope="col">{sumValue?.Available.toLocaleString()}</th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                </div >
                                {
                                    reports.length === 0 &&
                                    <div class="row" >
                                        <div class="col-12">
                                            <div class="not-found">
                                                ไม่พบข้อมูล
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div >

                        </div >

                    </form >
                </div >
            </Page >
        </div >
    )
}
